"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaAccountToJSON = exports.RosettaAccountFromJSONTyped = exports.RosettaAccountFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaAccountFromJSON(json) {
    return RosettaAccountFromJSONTyped(json, false);
}
exports.RosettaAccountFromJSON = RosettaAccountFromJSON;
function RosettaAccountFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'address': json['address'],
        'sub_account': !runtime_1.exists(json, 'sub_account') ? undefined : _1.RosettaSubAccountFromJSON(json['sub_account']),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : json['metadata'],
    };
}
exports.RosettaAccountFromJSONTyped = RosettaAccountFromJSONTyped;
function RosettaAccountToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'address': value.address,
        'sub_account': _1.RosettaSubAccountToJSON(value.sub_account),
        'metadata': value.metadata,
    };
}
exports.RosettaAccountToJSON = RosettaAccountToJSON;
//# sourceMappingURL=RosettaAccount.js.map